import React, { useState, useEffect } from "react";
import { getRequest } from "../../api";

const ChatMessage = ({
  content,
  isUser,
  onMessageCompleted,
  firstMessageforComponent,
  setFirstMessageforComponent,
}) => {

  const [displayedMessage, setDisplayedMessage] = useState("");
  const delay = firstMessageforComponent ? 80 : 65;
  const [selectedVoice, setSelectedVoice] = useState('Amy');
  const userId = Number(localStorage.getItem('userid')); 
  const [name, setName] = useState('');

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await getRequest('/user');
        setName(response.name);
      } catch (error) {
        console.error("Error Fetching User:", error);
        setName('Default');
      }
    };
    fetchUser();
  }, []);

  useEffect(() => {
    const fetchAvatar = async () => {
      try {
        const response = await getRequest('/user/get-avatar');
  
        if (response.error) {
          console.error("Error fetching avatar:", response.error);
          setSelectedVoice('Amy'); 
        } else {
          const avatar = response.avatar;
  
          if (avatar === 'Arthur' || avatar === 'Amy') {
            setSelectedVoice(avatar);
          } else {
            setSelectedVoice('Amy');
          }
        }
      } catch (error) {
        console.error("Error fetching avatar:", error);
        setSelectedVoice('Amy'); 
      }
    };
  
    if (userId) {
      fetchAvatar();
    } else {
      console.error("User ID is missing in localStorage.");
      setSelectedVoice('Amy'); 
    }
  }, [userId]);
  useEffect(() => {
    setDisplayedMessage("");
    if (!isUser) {
      let index = 0;
      const timer = setInterval(() => {
        setDisplayedMessage((prev) => prev + content[index]);
        index++;

        if (index === content.length) {
          clearInterval(timer);
          if (onMessageCompleted) {
            onMessageCompleted();
          }
        }
      }, delay);

      return () => {
        clearInterval(timer);
      };
    } else {
      setDisplayedMessage(content);
    }
  }, [content, isUser]);
  setFirstMessageforComponent(false);

  return (
    <div
      style={{
        width: "100%",
        marginBottom: "5px",
        textAlign: "center",
        color: "#000000",
        borderRadius: "5px",
      }}
    >
      <strong>{isUser ? `${name}` : `${selectedVoice}`}:</strong> {displayedMessage}
    </div>
  );
};

export default React.memo(ChatMessage);
